import IContractDuration from "@/module/main/dto/customer/IContractDuration";
import ContractDurationType from "@/module/main/dto/customer/ContractDurationTypeEnum";
import IFixedTerm from "@/module/main/dto/customer/IFixedTerm";

export default class ContractDuration implements IContractDuration {
    constructor(
        public type?: ContractDurationType, 
        public fixedTerm?: IFixedTerm, 
        public employedFrom?: string
    ) {}
}
